export default __webpack_public_path__ + "static/media/paywithcrypto.ced2f518.png";